import { Injectable } from '@angular/core';
import { ApiHelperService, ApiService } from '../../../shared/services/api';
import { FilterSettings } from '../models';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class FilterSettingsService {
  endpointUrl: string;

  constructor(
    private api: ApiService,
    { workspaceServiceUrl }: ApiHelperService) {
    this.endpointUrl = `${workspaceServiceUrl}/api/filtersettings`;
  }

  getFilterSettings(propertyId, reportId = null): Observable<FilterSettings> {
    const path = reportId
      ? `${this.endpointUrl}/${propertyId}/${reportId}`
      : `${this.endpointUrl}/${propertyId}`;

    return this.api.get(path).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  saveFilterSettings(filterSettings: FilterSettings): Observable<FilterSettings> {
    return this.api.post(`${this.endpointUrl}`, filterSettings).pipe(
      map(response => response.data),
      catchError((error) => this.handleError(error)));
  }

  private handleError(response: HttpErrorResponse) {
    return throwError(response?.error?.errors);
  }
}
